import { FETCH_RECIPE_IMAGES } from "../actions/types";

const recipeImages = (state = {}, action) => {
  switch (action.type) {
    case FETCH_RECIPE_IMAGES:
      return action.payload;
    default:
      return state;
  }
};

export default recipeImages;
